<!-- @format -->

<div
	id="reviews"
	class="ratings-and-reviews-content hmf-mb-l hmf-mb-m-xl"
	[ngClass]="{ 'hide-panel-body': !!displayRatingSummaryAndHideBody }">
	<common-accordion
		[isCollapsed]="isCollapsed"
		[hideHeading]="true"
		(accordionClicked)="setDisplayRatingSummaryAndHideBody($event)">
		<h2
			class="ratings-and-reviews-header hmf-flex-grow"
			myPanelHeader>
			Customer Reviews
		</h2>
		<div
			class="ratings-and-reviews-header-secondary hmf-flex-grow"
			myPanelHeaderSecondary>
			<div
				class="ratings-text"
				id="ratings"
				[ngClass]="{ 'hide-review-summary': !displayRatingSummaryAndHideBody }">
				<div
					data-bv-show="rating_summary"
					data-bv-seo="false"
					[attr.data-bv-product-id]="productIdentifier"
					id="bv-review-summary"></div>
			</div>
		</div>

		<div
			class="panel-content ratings-and-reviews-body"
			myPanelBody>
			<div
				data-bv-show="reviews"
				data-bv-seo="false"
				[attr.data-bv-product-id]="productIdentifier">
				<div
					*ngIf="reviewSummary?.reviewCount !== null"
					id="ratings-progress-spinner"
					class="ratings-progress-spinner">
					<common-progress-spinner
						[diameter]="45"
						[strokeWidth]="4"></common-progress-spinner>
				</div>
			</div>
		</div>
	</common-accordion>
</div>
